export let ToastRootCssVars = /*#__PURE__*/function (ToastRootCssVars) {
  /**
   * Indicates the index of the toast in the list.
   * @type {number}
   */
  ToastRootCssVars["index"] = "--toast-index";
  /**
   * Indicates the vertical pixels offset of the toast in the list when expanded.
   * @type {number}
   */
  ToastRootCssVars["offsetY"] = "--toast-offset-y";
  /**
   * Indicates the horizontal swipe movement of the toast.
   * @type {number}
   */
  ToastRootCssVars["swipeMovementX"] = "--toast-swipe-movement-x";
  /**
   * Indicates the vertical swipe movement of the toast.
   * @type {number}
   */
  ToastRootCssVars["swipeMovementY"] = "--toast-swipe-movement-y";
  return ToastRootCssVars;
}({});